// // import React, { useState, useEffect, useCallback, useRef } from 'react';
// // import { User, Mail, Phone, Building, MapPin, CreditCard, Save, X, Loader2, CheckCircle2, Unlink } from 'lucide-react';
// // import { toast } from "react-toastify";
// // import { authAPI } from "../../services/api";

// // const GoogleIcon = ({ size = 20 }) => (
// //   <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
// //     <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
// //     <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
// //     <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
// //     <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
// //   </svg>
// // );

// // const MicrosoftIcon = ({ size = 16 }) => (
// //   <svg width={size} height={size} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
// //     <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
// //     <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
// //     <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
// //     <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
// //   </svg>
// // );

// // const Profile = () => {
// //   const [profile, setProfile] = useState(null);
// //   // Single loading flag covers profile + all statuses — no partial renders
// //   const [loading, setLoading] = useState(true);
// //   const [isEditing, setIsEditing] = useState(false);
// //   const [editedProfile, setEditedProfile] = useState(null);

// //   // Connection states — initialised as null (unknown) to avoid premature "not connected" flash
// //   const [googleConnected, setGoogleConnected] = useState(null);
// //   const [microsoftConnected, setMicrosoftConnected] = useState(null);
// //   const [defaultProvider, setDefaultProvider] = useState(null);

// //   // Per-action loading only (not for status checks — those happen inside the main load)
// //   const [googleActionLoading, setGoogleActionLoading] = useState(false);
// //   const [microsoftActionLoading, setMicrosoftActionLoading] = useState(false);
// //   const [defaultProviderActionLoading, setDefaultProviderActionLoading] = useState(false);

// //   const hasFetchedRef = useRef(false);

// //   // ─── Fetch everything in one shot, set ALL state together at the end ─────────
// //   const fetchAll = useCallback(async () => {
// //     if (hasFetchedRef.current) return;
// //     hasFetchedRef.current = true;
// //     // loading starts true from useState — no extra setLoading(true) needed

// //     try {
// //       const email = localStorage.getItem('userEmail') || localStorage.getItem('email');
// //       if (!email) {
// //         toast.error('User email not found. Please login again.');
// //         setLoading(false);
// //         return;
// //       }

// //       // 1. Profile first (need userId for subsequent calls)
// //       const profileRes = await authAPI.getProfile(email);
// //       const data = profileRes.data;
// //       const userId = data?.id;

// //       if (!userId) {
// //         // Still set profile so the "no data" state renders correctly
// //         setProfile(data);
// //         setEditedProfile(data);
// //         setLoading(false);
// //         return;
// //       }

// //       // 2. All status calls in parallel — nothing is set to state yet
// //       const [googleRes, microsoftRes, providerRes] = await Promise.allSettled([
// //         authAPI.googleStatus(userId),
// //         authAPI.microsoftStatus(userId),
// //         authAPI.getDefaultProvider(userId),
// //       ]);

// //       const googleConn = googleRes.status === 'fulfilled'
// //         ? (googleRes.value.data?.connected ?? googleRes.value.data?.status === 'connected' ?? false)
// //         : false;

// //       const microsoftConn = microsoftRes.status === 'fulfilled'
// //         ? (microsoftRes.value.data?.connected ?? microsoftRes.value.data?.status === 'connected' ?? false)
// //         : false;

// //       const provider = providerRes.status === 'fulfilled'
// //         ? (providerRes.value.data?.defaultProvider || providerRes.value.data?.provider || null)
// //         : null;

// //       // ── Single synchronous batch — React commits exactly ONE render ──────────
// //       setProfile(data);
// //       setEditedProfile(data);
// //       setGoogleConnected(googleConn);
// //       setMicrosoftConnected(microsoftConn);
// //       setDefaultProvider(provider);

// //     } catch (error) {
// //       console.error('Error fetching profile:', error);
// //       toast.error('Failed to fetch profile information');
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, []);

// //   useEffect(() => {
// //     fetchAll();
// //   }, [fetchAll]);

// //   // ─── Helpers ─────────────────────────────────────────────────────────────────
// //   const getUserId = () => profile?.id || localStorage.getItem('userId');

// //   const handleSetDefaultProvider = async (provider) => {
// //     try {
// //       setDefaultProviderActionLoading(true);
// //       const userId = getUserId();
// //       if (!userId) { toast.error('User ID not found. Please login again.'); return; }
// //       await authAPI.setDefaultProvider(userId, provider);
// //       setDefaultProvider(provider);
// //       toast.success(`Default provider set to ${provider}`);
// //     } catch (error) {
// //       console.error('Error setting default provider:', error);
// //       toast.error('Failed to set default provider');
// //     } finally {
// //       setDefaultProviderActionLoading(false);
// //     }
// //   };

// //   // ─── Google handlers ──────────────────────────────────────────────────────────
// //   const handleConnectGoogle = async () => {
// //     try {
// //       setGoogleActionLoading(true);
// //       const userId = getUserId();
// //       if (!userId) { toast.error('User ID not found. Please login again.'); return; }
// //       const response = await authAPI.connectGoogle(userId);
// //       const { url } = response.data;
// //       if (url) { window.location.href = url; }
// //       else { toast.error('Failed to get Google authorization URL'); }
// //     } catch (error) {
// //       console.error('Error connecting Google:', error);
// //       toast.error('Failed to initiate Google connection');
// //     } finally {
// //       setGoogleActionLoading(false);
// //     }
// //   };

// //   const handleDisconnectGoogle = async () => {
// //     try {
// //       setGoogleActionLoading(true);
// //       const userId = getUserId();
// //       if (!userId) { toast.error('User ID not found. Please login again.'); return; }
// //       await authAPI.disconnectGoogle(userId);
// //       setGoogleConnected(false);
// //       toast.success('Google account disconnected successfully');
// //     } catch (error) {
// //       console.error('Error disconnecting Google:', error);
// //       toast.error('Failed to disconnect Google account');
// //     } finally {
// //       setGoogleActionLoading(false);
// //     }
// //   };

// //   // ─── Microsoft handlers ───────────────────────────────────────────────────────
// //   const handleConnectMicrosoft = async () => {
// //     try {
// //       setMicrosoftActionLoading(true);
// //       const userId = getUserId();
// //       if (!userId) { toast.error('User ID not found. Please login again.'); return; }
// //       const response = await authAPI.connectMicrosoft(userId);
// //       const { url } = response.data;
// //       if (url) { window.location.href = url; }
// //       else { toast.error('Failed to get Microsoft authorization URL'); }
// //     } catch (error) {
// //       console.error('Error connecting Microsoft:', error);
// //       toast.error('Failed to initiate Microsoft connection');
// //     } finally {
// //       setMicrosoftActionLoading(false);
// //     }
// //   };

// //   const handleDisconnectMicrosoft = async () => {
// //     try {
// //       setMicrosoftActionLoading(true);
// //       const userId = getUserId();
// //       if (!userId) { toast.error('User ID not found. Please login again.'); return; }
// //       await authAPI.disconnectMicrosoft(userId);
// //       setMicrosoftConnected(false);
// //       toast.success('Microsoft account disconnected successfully');
// //     } catch (error) {
// //       console.error('Error disconnecting Microsoft:', error);
// //       toast.error('Failed to disconnect Microsoft account');
// //     } finally {
// //       setMicrosoftActionLoading(false);
// //     }
// //   };

// //   // ─── Edit handlers ────────────────────────────────────────────────────────────
// //   const handleCancel = () => { setIsEditing(false); setEditedProfile({ ...profile }); };

// //   const handleSave = async () => {
// //     try {
// //       setProfile(editedProfile);
// //       setIsEditing(false);
// //       toast.success('Profile updated successfully');
// //     } catch (error) {
// //       console.error('Error updating profile:', error);
// //       toast.error('Failed to update profile');
// //     }
// //   };

// //   const handleInputChange = (field, value) => {
// //     setEditedProfile(prev => ({ ...prev, [field]: value }));
// //   };

// //   // ─── Formatters / badges ──────────────────────────────────────────────────────
// //   const formatDate = (dateString) => {
// //     if (!dateString) return 'N/A';
// //     return new Date(dateString).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' });
// //   };

// //   const getStatusBadge = (status) => {
// //     const cfg = {
// //       ACTIVATED: { bg: 'bg-green-100', text: 'text-green-800', label: 'Active' },
// //       DEACTIVATED: { bg: 'bg-red-100', text: 'text-red-800', label: 'Inactive' },
// //       PENDING: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Pending' },
// //     };
// //     const c = cfg[status] || cfg.PENDING;
// //     return <span className={`px-3 py-1 text-xs font-medium rounded-full ${c.bg} ${c.text}`}>{c.label}</span>;
// //   };

// //   const getPaymentStatusBadge = (status) => {
// //     const cfg = {
// //       PAID: { bg: 'bg-green-100', text: 'text-green-800' },
// //       UNPAID: { bg: 'bg-red-100', text: 'text-red-800' },
// //       PENDING: { bg: 'bg-yellow-100', text: 'text-yellow-800' },
// //     };
// //     const c = cfg[status] || cfg.UNPAID;
// //     return <span className={`px-3 py-1 text-xs font-medium rounded-full ${c.bg} ${c.text}`}>{status}</span>;
// //   };

// //   // ─── Full-page loader — shown until profile AND all statuses are resolved ──────
// //   if (loading) {
// //     return (
// //       <div className="flex items-center justify-center h-screen bg-gray-50">
// //         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
// //       </div>
// //     );
// //   }

// //   if (!profile) {
// //     return (
// //       <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
// //         <User size={64} className="text-gray-300 mb-4" />
// //         <p className="text-lg font-medium text-gray-600">No profile data available</p>
// //       </div>
// //     );
// //   }

// //   const currentData = isEditing ? editedProfile : profile;

// //   // ─── Render ───────────────────────────────────────────────────────────────────
// //   return (
// //     <div className="min-h-screen bg-gray-50">
// //       {/* Header */}
// //       <div className="bg-white border-b">
// //         <div className="max-w-7xl mx-auto px-6 py-6">
// //           <div className="flex items-center justify-between">
// //             <div>
// //               <h1 className="text-2xl font-bold text-gray-900">My Profile</h1>
// //               <p className="text-sm text-gray-500 mt-1">Manage your account information</p>
// //             </div>

// //             <div className="flex items-center gap-3">
// //               {!isEditing ? (
// //                 <>
// //                   {/* Google — Connect or Disconnect */}
// //                   {googleConnected ? (
// //                     <button
// //                       onClick={handleDisconnectGoogle}
// //                       disabled={googleActionLoading}
// //                       className="px-4 py-2 text-sm bg-white border border-red-200 text-red-600 rounded-md hover:bg-red-50 hover:border-red-300 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
// //                     >
// //                       {googleActionLoading ? <Loader2 size={16} className="animate-spin" /> : <><GoogleIcon size={16} /><Unlink size={14} /></>}
// //                       {googleActionLoading ? 'Disconnecting...' : 'Disconnect Google'}
// //                     </button>
// //                   ) : (
// //                     <button
// //                       onClick={handleConnectGoogle}
// //                       disabled={googleActionLoading}
// //                       className="px-4 py-2 text-sm bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 hover:border-gray-400 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
// //                     >
// //                       {googleActionLoading ? <Loader2 size={16} className="animate-spin text-gray-500" /> : <GoogleIcon size={16} />}
// //                       {googleActionLoading ? 'Connecting...' : 'Sync with Google'}
// //                     </button>
// //                   )}

// //                   {/* Microsoft — Connect or Disconnect */}
// //                   {microsoftConnected ? (
// //                     <button
// //                       onClick={handleDisconnectMicrosoft}
// //                       disabled={microsoftActionLoading}
// //                       className="px-4 py-2 text-sm bg-white border border-red-200 text-red-600 rounded-md hover:bg-red-50 hover:border-red-300 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
// //                     >
// //                       {microsoftActionLoading ? <Loader2 size={16} className="animate-spin" /> : <><MicrosoftIcon size={16} /><Unlink size={14} /></>}
// //                       {microsoftActionLoading ? 'Disconnecting...' : 'Disconnect Microsoft'}
// //                     </button>
// //                   ) : (
// //                     <button
// //                       onClick={handleConnectMicrosoft}
// //                       disabled={microsoftActionLoading}
// //                       className="px-4 py-2 text-sm bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 hover:border-gray-400 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
// //                     >
// //                       {microsoftActionLoading ? <Loader2 size={16} className="animate-spin text-gray-500" /> : <MicrosoftIcon size={16} />}
// //                       {microsoftActionLoading ? 'Connecting...' : 'Sync with Microsoft'}
// //                     </button>
// //                   )}
// //                 </>
// //               ) : (
// //                 <>
// //                   <button onClick={handleCancel} className="px-4 py-2 text-sm border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 flex items-center gap-2">
// //                     <X size={16} /> Cancel
// //                   </button>
// //                   <button onClick={handleSave} className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-2">
// //                     <Save size={16} /> Save Changes
// //                   </button>
// //                 </>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Content */}
// //       <div className="max-w-7xl mx-auto px-6 py-8">
// //         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

// //           {/* ── Main Profile Cards ─────────────────────────────────────────────── */}
// //           <div className="lg:col-span-2 space-y-6">

// //             {/* Personal Information */}
// //             <div className="bg-white rounded-lg shadow-sm border">
// //               <div className="px-6 py-4 border-b">
// //                 <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><User size={20} />Personal Information</h2>
// //               </div>
// //               <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">First Name</label>
// //                   {isEditing ? (
// //                     <input type="text" value={currentData.firstName || ''} onChange={(e) => handleInputChange('firstName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
// //                   ) : (
// //                     <p className="text-sm text-gray-900 font-medium">{currentData.firstName || '-'}</p>
// //                   )}
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">Last Name</label>
// //                   {isEditing ? (
// //                     <input type="text" value={currentData.lastName || ''} onChange={(e) => handleInputChange('lastName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
// //                   ) : (
// //                     <p className="text-sm text-gray-900 font-medium">{currentData.lastName || '-'}</p>
// //                   )}
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">Email</label>
// //                   <p className="text-sm text-gray-900 font-medium flex items-center gap-2">
// //                     <Mail size={14} className="text-gray-400" />{currentData.email || '-'}
// //                   </p>
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">Contact Number</label>
// //                   {isEditing ? (
// //                     <div className="flex gap-2">
// //                       <input type="text" value={currentData.countryCode || '+91'} onChange={(e) => handleInputChange('countryCode', e.target.value)} className="w-20 px-3 py-2 border border-gray-300 rounded-md text-sm" />
// //                       <input type="text" value={currentData.contactNumber || ''} onChange={(e) => handleInputChange('contactNumber', e.target.value)} className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm" />
// //                     </div>
// //                   ) : (
// //                     <p className="text-sm text-gray-900 font-medium flex items-center gap-2">
// //                       <Phone size={14} className="text-gray-400" />{currentData.countryCode} {currentData.contactNumber || '-'}
// //                     </p>
// //                   )}
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">Role</label>
// //                   <p className="text-sm text-gray-900 font-medium">{currentData.role || '-'}</p>
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">Created At</label>
// //                   <p className="text-sm text-gray-900">{formatDate(currentData.createdAt)}</p>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Organization Information */}
// //             <div className="bg-white rounded-lg shadow-sm border">
// //               <div className="px-6 py-4 border-b">
// //                 <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><Building size={20} />Organization Details</h2>
// //               </div>
// //               <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">Organization Name</label>
// //                   {isEditing ? (
// //                     <input type="text" value={currentData.organizationName || ''} onChange={(e) => handleInputChange('organizationName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
// //                   ) : (
// //                     <p className="text-sm text-gray-900 font-medium">{currentData.organizationName || '-'}</p>
// //                   )}
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">Organization Type</label>
// //                   {isEditing ? (
// //                     <select value={currentData.organizationType || 'CORPORATE'} onChange={(e) => handleInputChange('organizationType', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm">
// //                       <option value="CORPORATE">Corporate</option>
// //                       <option value="INDIVIDUAL">Individual</option>
// //                       <option value="PARTNERSHIP">Partnership</option>
// //                       <option value="LLP">LLP</option>
// //                     </select>
// //                   ) : (
// //                     <p className="text-sm text-gray-900 font-medium">{currentData.organizationType || '-'}</p>
// //                   )}
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">GST Number</label>
// //                   {isEditing ? (
// //                     <input type="text" value={currentData.gstnumber || ''} onChange={(e) => handleInputChange('gstnumber', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
// //                   ) : (
// //                     <p className="text-sm text-gray-900 font-medium">{currentData.gstnumber || '-'}</p>
// //                   )}
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">PAN Number</label>
// //                   {isEditing ? (
// //                     <input type="text" value={currentData.pannumber || ''} onChange={(e) => handleInputChange('pannumber', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
// //                   ) : (
// //                     <p className="text-sm text-gray-900 font-medium">{currentData.pannumber || '-'}</p>
// //                   )}
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Address */}
// //             <div className="bg-white rounded-lg shadow-sm border">
// //               <div className="px-6 py-4 border-b">
// //                 <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><MapPin size={20} />Address</h2>
// //               </div>
// //               <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
// //                 {[
// //                   { label: 'Street Line 1', field: 'streetLine1', span: true },
// //                   { label: 'Street Line 2', field: 'streetLine2', span: true },
// //                   { label: 'City', field: 'city' },
// //                   { label: 'State', field: 'state' },
// //                   { label: 'Country', field: 'country' },
// //                   { label: 'Zipcode', field: 'zipcode' },
// //                 ].map(({ label, field, span }) => (
// //                   <div key={field} className={span ? 'md:col-span-2' : ''}>
// //                     <label className="block text-xs font-medium text-gray-500 mb-1">{label}</label>
// //                     {isEditing ? (
// //                       <input type="text" value={currentData[field] || ''} onChange={(e) => handleInputChange(field, e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
// //                     ) : (
// //                       <p className="text-sm text-gray-900">{currentData[field] || '-'}</p>
// //                     )}
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>

// //             {/* Bank Details */}
// //             <div className="bg-white rounded-lg shadow-sm border">
// //               <div className="px-6 py-4 border-b">
// //                 <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><CreditCard size={20} />Bank Details</h2>
// //               </div>
// //               <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
// //                 {[
// //                   { label: 'Account Number', field: 'accountno' },
// //                   { label: 'IFSC Code', field: 'ifsccode' },
// //                   { label: 'Account Name', field: 'accountname' },
// //                   { label: 'Bank Name', field: 'bankname' },
// //                 ].map(({ label, field }) => (
// //                   <div key={field}>
// //                     <label className="block text-xs font-medium text-gray-500 mb-1">{label}</label>
// //                     {isEditing ? (
// //                       <input type="text" value={currentData[field] || ''} onChange={(e) => handleInputChange(field, e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
// //                     ) : (
// //                       <p className="text-sm text-gray-900 font-medium">{currentData[field] || '-'}</p>
// //                     )}
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //           </div>

// //           {/* ── Sidebar ────────────────────────────────────────────────────────── */}
// //           <div className="space-y-6">

// //             {/* Account Status */}
// //             <div className="bg-white rounded-lg shadow-sm border">
// //               <div className="px-6 py-4 border-b">
// //                 <h2 className="text-lg font-semibold text-gray-900">Account Status</h2>
// //               </div>
// //               <div className="p-6 space-y-4">
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-2">Account Status</label>
// //                   {getStatusBadge(currentData.actionStatus)}
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-2">Payment Status</label>
// //                   {getPaymentStatusBadge(currentData.paymentStatus)}
// //                 </div>
// //                 <div>
// //                   <label className="block text-xs font-medium text-gray-500 mb-1">Number of Users</label>
// //                   <p className="text-2xl font-bold text-gray-900">{currentData.noOfUsers || 0}</p>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Connected Accounts */}
// //             <div className="bg-white rounded-lg shadow-sm border">
// //               <div className="px-6 py-4 border-b">
// //                 <h2 className="text-lg font-semibold text-gray-900">Connected Accounts</h2>
// //                 <p className="text-xs text-gray-500 mt-1">Sync your calendar &amp; contacts</p>
// //               </div>
// //               <div className="p-6 space-y-3">

// //                 {/* Google */}
// //                 {googleConnected ? (
// //                   <div className="w-full rounded-lg border border-green-200 bg-green-50 overflow-hidden">
// //                     <div className="flex items-center gap-3 px-4 py-3">
// //                       <GoogleIcon size={20} />
// //                       <div className="flex-1 min-w-0">
// //                         <div className="flex items-center gap-2">
// //                           <p className="text-sm font-medium text-gray-800">Google</p>
// //                           <span className="flex items-center gap-1 text-xs font-medium text-green-700 bg-green-100 px-2 py-0.5 rounded-full">
// //                             <CheckCircle2 size={10} /> Connected
// //                           </span>
// //                         </div>
// //                         <p className="text-xs text-gray-400">Gmail &amp; Google Calendar</p>
// //                       </div>
// //                     </div>
// //                     <button
// //                       onClick={handleDisconnectGoogle}
// //                       disabled={googleActionLoading}
// //                       className="w-full flex items-center justify-center gap-2 px-4 py-2 text-xs font-medium text-red-600 hover:bg-red-50 border-t border-green-200 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
// //                     >
// //                       {googleActionLoading ? <Loader2 size={12} className="animate-spin" /> : <Unlink size={12} />}
// //                       {googleActionLoading ? 'Disconnecting...' : 'Disconnect'}
// //                     </button>
// //                   </div>
// //                 ) : (
// //                   <button
// //                     onClick={handleConnectGoogle}
// //                     disabled={googleActionLoading}
// //                     className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all text-left group disabled:opacity-60 disabled:cursor-not-allowed"
// //                   >
// //                     {googleActionLoading ? <Loader2 size={20} className="animate-spin text-gray-400 shrink-0" /> : <GoogleIcon size={20} />}
// //                     <div className="flex-1 min-w-0">
// //                       <p className="text-sm font-medium text-gray-800 group-hover:text-blue-700">
// //                         {googleActionLoading ? 'Connecting...' : 'Connect Google'}
// //                       </p>
// //                       <p className="text-xs text-gray-400">Gmail &amp; Google Calendar</p>
// //                     </div>
// //                     <span className="text-xs text-gray-400 group-hover:text-blue-500">→</span>
// //                   </button>
// //                 )}

// //                 {/* Microsoft */}
// //                 {microsoftConnected ? (
// //                   <div className="w-full rounded-lg border border-blue-200 bg-blue-50 overflow-hidden">
// //                     <div className="flex items-center gap-3 px-4 py-3">
// //                       <MicrosoftIcon size={20} />
// //                       <div className="flex-1 min-w-0">
// //                         <div className="flex items-center gap-2">
// //                           <p className="text-sm font-medium text-gray-800">Microsoft</p>
// //                           <span className="flex items-center gap-1 text-xs font-medium text-blue-700 bg-blue-100 px-2 py-0.5 rounded-full">
// //                             <CheckCircle2 size={10} /> Connected
// //                           </span>
// //                         </div>
// //                         <p className="text-xs text-gray-400">Outlook &amp; Teams</p>
// //                       </div>
// //                     </div>
// //                     <button
// //                       onClick={handleDisconnectMicrosoft}
// //                       disabled={microsoftActionLoading}
// //                       className="w-full flex items-center justify-center gap-2 px-4 py-2 text-xs font-medium text-red-600 hover:bg-red-50 border-t border-blue-200 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
// //                     >
// //                       {microsoftActionLoading ? <Loader2 size={12} className="animate-spin" /> : <Unlink size={12} />}
// //                       {microsoftActionLoading ? 'Disconnecting...' : 'Disconnect'}
// //                     </button>
// //                   </div>
// //                 ) : (
// //                   <button
// //                     onClick={handleConnectMicrosoft}
// //                     disabled={microsoftActionLoading}
// //                     className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all text-left group disabled:opacity-60 disabled:cursor-not-allowed"
// //                   >
// //                     {microsoftActionLoading ? <Loader2 size={20} className="animate-spin text-gray-400 shrink-0" /> : <MicrosoftIcon size={20} />}
// //                     <div className="flex-1 min-w-0">
// //                       <p className="text-sm font-medium text-gray-800 group-hover:text-blue-700">
// //                         {microsoftActionLoading ? 'Connecting...' : 'Connect Microsoft'}
// //                       </p>
// //                       <p className="text-xs text-gray-400">Outlook &amp; Teams</p>
// //                     </div>
// //                     <span className="text-xs text-gray-400 group-hover:text-blue-500">→</span>
// //                   </button>
// //                 )}

// //                 {/* Default Provider — only shown when both are connected */}
// //                 {googleConnected && microsoftConnected && (
// //                   <div className="mt-4 pt-4 border-t border-gray-200">
// //                     <h3 className="text-sm font-semibold text-gray-900 mb-3">Default Provider</h3>
// //                     <label className="block text-xs font-medium text-gray-600 mb-2">Choose your default sync provider</label>
// //                     <div className="flex gap-2">
// //                       <select
// //                         value={defaultProvider || ''}
// //                         onChange={(e) => handleSetDefaultProvider(e.target.value)}
// //                         disabled={defaultProviderActionLoading}
// //                         className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed bg-white"
// //                       >
// //                         <option value="">Select Default Provider</option>
// //                         <option value="google">Google</option>
// //                         <option value="microsoft">Microsoft</option>
// //                       </select>
// //                       {defaultProviderActionLoading && (
// //                         <div className="flex items-center px-3">
// //                           <Loader2 size={16} className="animate-spin text-blue-600" />
// //                         </div>
// //                       )}
// //                     </div>
// //                     {defaultProvider && (
// //                       <div className="mt-2 flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-50 border border-blue-200">
// //                         <CheckCircle2 size={16} className="text-blue-600" />
// //                         <span className="text-xs text-blue-700">
// //                           Currently using <strong>{defaultProvider.charAt(0).toUpperCase() + defaultProvider.slice(1)}</strong>
// //                         </span>
// //                       </div>
// //                     )}
// //                   </div>
// //                 )}
// //               </div>
// //             </div>

// //             {/* Account Summary */}
// //             <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg shadow-sm text-white p-6">
// //               <h3 className="text-lg font-semibold mb-4">Account Summary</h3>
// //               <div className="space-y-3">
// //                 <div className="flex items-center justify-between">
// //                   <span className="text-blue-100 text-sm">Member Since</span>
// //                   <span className="font-medium text-sm">{formatDate(currentData.createdAt)}</span>
// //                 </div>
// //                 <div className="flex items-center justify-between">
// //                   <span className="text-blue-100 text-sm">Account ID</span>
// //                   <span className="font-mono text-xs">{currentData.id?.slice(0, 8)}...</span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Profile;

// import React, { useState, useEffect } from 'react';
// import { User, Mail, Phone, Building, MapPin, CreditCard, Save, X, Loader2, CheckCircle2, Unlink } from 'lucide-react';
// import { toast } from "react-toastify";
// import { authAPI } from "../../services/api";

// const GoogleIcon = ({ size = 20 }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
//     <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
//     <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
//     <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
//     <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
//   </svg>
// );

// const MicrosoftIcon = ({ size = 16 }) => (
//   <svg width={size} height={size} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
//     <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
//     <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
//     <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
//     <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
//   </svg>
// );

// const Profile = () => {
//   const [profile, setProfile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editedProfile, setEditedProfile] = useState(null);

//   // Google connection states
//   const [googleConnected, setGoogleConnected] = useState(false);
//   const [googleStatusLoading, setGoogleStatusLoading] = useState(false);
//   const [googleActionLoading, setGoogleActionLoading] = useState(false);

//   // Microsoft connection states
//   const [microsoftConnected, setMicrosoftConnected] = useState(false);
//   const [microsoftStatusLoading, setMicrosoftStatusLoading] = useState(false);
//   const [microsoftActionLoading, setMicrosoftActionLoading] = useState(false);

//   const getUserId = () => profile?.id || localStorage.getItem('userId');

//   const fetchProfile = async () => {
//     setLoading(true);
//     try {
//       const email = localStorage.getItem('userEmail') || localStorage.getItem('email');
//       if (!email) {
//         toast.error('User email not found. Please login again.');
//         return;
//       }
//       const response = await authAPI.getProfile(email);
//       const data = response.data;
//       setProfile(data);
//       setEditedProfile(data);
//     } catch (error) {
//       console.error('Error fetching profile:', error);
//       toast.error('Failed to fetch profile information');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchGoogleStatus = async (userId) => {
//     if (!userId) return;
//     setGoogleStatusLoading(true);
//     try {
//       const response = await authAPI.googleStatus(userId);
//       const connected = response.data?.connected ?? response.data?.status === 'connected' ?? false;
//       setGoogleConnected(connected);
//     } catch (error) {
//       console.error('Error fetching Google status:', error);
//       setGoogleConnected(false);
//     } finally {
//       setGoogleStatusLoading(false);
//     }
//   };

//   const fetchMicrosoftStatus = async (userId) => {
//     if (!userId) return;
//     setMicrosoftStatusLoading(true);
//     try {
//       const response = await authAPI.microsoftStatus(userId);
//       const connected = response.data?.connected ?? response.data?.status === 'connected' ?? false;
//       setMicrosoftConnected(connected);
//     } catch (error) {
//       console.error('Error fetching Microsoft status:', error);
//       setMicrosoftConnected(false);
//     } finally {
//       setMicrosoftStatusLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProfile();
//   }, []);

//   // Once profile loads, check Google & Microsoft status
//   useEffect(() => {
//     if (profile?.id) {
//       fetchGoogleStatus(profile.id);
//       fetchMicrosoftStatus(profile.id);
//     }
//   }, [profile?.id]);

//   // Handle Google OAuth connect — redirects to Google
//   const handleConnectGoogle = async () => {
//     try {
//       setGoogleActionLoading(true);
//       const userId = getUserId();
//       if (!userId) {
//         toast.error('User ID not found. Please login again.');
//         return;
//       }
//       const response = await authAPI.connectGoogle(userId);
//       const { url } = response.data;
//       if (url) {
//         window.location.href = url;
//       } else {
//         toast.error('Failed to get Google authorization URL');
//       }
//     } catch (error) {
//       console.error('Error connecting Google:', error);
//       toast.error('Failed to initiate Google connection');
//     } finally {
//       setGoogleActionLoading(false);
//     }
//   };

//   // Handle Google disconnect
//   const handleDisconnectGoogle = async () => {
//     try {
//       setGoogleActionLoading(true);
//       const userId = getUserId();
//       if (!userId) {
//         toast.error('User ID not found. Please login again.');
//         return;
//       }
//       await authAPI.disconnectGoogle(userId);
//       setGoogleConnected(false);
//       toast.success('Google account disconnected successfully');
//     } catch (error) {
//       console.error('Error disconnecting Google:', error);
//       toast.error('Failed to disconnect Google account');
//     } finally {
//       setGoogleActionLoading(false);
//     }
//   };

//   // Handle Microsoft OAuth connect — redirects to Microsoft
//   const handleConnectMicrosoft = async () => {
//     try {
//       setMicrosoftActionLoading(true);
//       const userId = getUserId();
//       if (!userId) {
//         toast.error('User ID not found. Please login again.');
//         return;
//       }
//       const response = await authAPI.connectMicrosoft(userId);
//       const { url } = response.data;
//       if (url) {
//         window.location.href = url;
//       } else {
//         toast.error('Failed to get Microsoft authorization URL');
//       }
//     } catch (error) {
//       console.error('Error connecting Microsoft:', error);
//       toast.error('Failed to initiate Microsoft connection');
//     } finally {
//       setMicrosoftActionLoading(false);
//     }
//   };

//   // Handle Microsoft disconnect
//   const handleDisconnectMicrosoft = async () => {
//     try {
//       setMicrosoftActionLoading(true);
//       const userId = getUserId();
//       if (!userId) {
//         toast.error('User ID not found. Please login again.');
//         return;
//       }
//       await authAPI.disconnectMicrosoft(userId);
//       setMicrosoftConnected(false);
//       toast.success('Microsoft account disconnected successfully');
//     } catch (error) {
//       console.error('Error disconnecting Microsoft:', error);
//       toast.error('Failed to disconnect Microsoft account');
//     } finally {
//       setMicrosoftActionLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     setIsEditing(false);
//     setEditedProfile({ ...profile });
//   };

//   const handleSave = async () => {
//     try {
//       setProfile(editedProfile);
//       setIsEditing(false);
//       toast.success('Profile updated successfully');
//     } catch (error) {
//       console.error('Error updating profile:', error);
//       toast.error('Failed to update profile');
//     }
//   };

//   const handleInputChange = (field, value) => {
//     setEditedProfile(prev => ({ ...prev, [field]: value }));
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-IN', {
//       year: 'numeric', month: 'long', day: 'numeric'
//     });
//   };

//   const getStatusBadge = (status) => {
//     const statusConfig = {
//       ACTIVATED: { bg: 'bg-green-100', text: 'text-green-800', label: 'Active' },
//       DEACTIVATED: { bg: 'bg-red-100', text: 'text-red-800', label: 'Inactive' },
//       PENDING: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Pending' }
//     };
//     const config = statusConfig[status] || statusConfig.PENDING;
//     return (
//       <span className={`px-3 py-1 text-xs font-medium rounded-full ${config.bg} ${config.text}`}>
//         {config.label}
//       </span>
//     );
//   };

//   const getPaymentStatusBadge = (status) => {
//     const statusConfig = {
//       PAID: { bg: 'bg-green-100', text: 'text-green-800' },
//       UNPAID: { bg: 'bg-red-100', text: 'text-red-800' },
//       PENDING: { bg: 'bg-yellow-100', text: 'text-yellow-800' }
//     };
//     const config = statusConfig[status] || statusConfig.UNPAID;
//     return (
//       <span className={`px-3 py-1 text-xs font-medium rounded-full ${config.bg} ${config.text}`}>
//         {status}
//       </span>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-screen bg-gray-50">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
//       </div>
//     );
//   }

//   if (!profile) {
//     return (
//       <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
//         <User size={64} className="text-gray-300 mb-4" />
//         <p className="text-lg font-medium text-gray-600">No profile data available</p>
//       </div>
//     );
//   }

//   const currentData = isEditing ? editedProfile : profile;

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <div className="bg-white border-b">
//         <div className="max-w-7xl mx-auto px-6 py-6">
//           <div className="flex items-center justify-between">
//             <div>
//               <h1 className="text-2xl font-bold text-gray-900">My Profile</h1>
//               <p className="text-sm text-gray-500 mt-1">Manage your account information</p>
//             </div>

//             <div className="flex items-center gap-3">
//               {!isEditing ? (
//                 <>
//                   {/* Google — Connect or Disconnect */}
//                   {googleStatusLoading ? (
//                     <div className="px-4 py-2 flex items-center gap-2 text-sm text-gray-400 border border-gray-200 rounded-md bg-white">
//                       <Loader2 size={14} className="animate-spin" />
//                       Checking Google...
//                     </div>
//                   ) : googleConnected ? (
//                     <button
//                       onClick={handleDisconnectGoogle}
//                       disabled={googleActionLoading}
//                       className="px-4 py-2 text-sm bg-white border border-red-200 text-red-600 rounded-md hover:bg-red-50 hover:border-red-300 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
//                     >
//                       {googleActionLoading ? (
//                         <Loader2 size={16} className="animate-spin" />
//                       ) : (
//                         <>
//                           <GoogleIcon size={16} />
//                           <Unlink size={14} />
//                         </>
//                       )}
//                       {googleActionLoading ? 'Disconnecting...' : 'Disconnect Google'}
//                     </button>
//                   ) : (
//                     <button
//                       onClick={handleConnectGoogle}
//                       disabled={googleActionLoading}
//                       className="px-4 py-2 text-sm bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 hover:border-gray-400 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
//                     >
//                       {googleActionLoading ? (
//                         <Loader2 size={16} className="animate-spin text-gray-500" />
//                       ) : (
//                         <GoogleIcon size={16} />
//                       )}
//                       {googleActionLoading ? 'Connecting...' : 'Sync with Google'}
//                     </button>
//                   )}

//                   {/* Microsoft — Connect or Disconnect */}
//                   {microsoftStatusLoading ? (
//                     <div className="px-4 py-2 flex items-center gap-2 text-sm text-gray-400 border border-gray-200 rounded-md bg-white">
//                       <Loader2 size={14} className="animate-spin" />
//                       Checking Microsoft...
//                     </div>
//                   ) : microsoftConnected ? (
//                     <button
//                       onClick={handleDisconnectMicrosoft}
//                       disabled={microsoftActionLoading}
//                       className="px-4 py-2 text-sm bg-white border border-red-200 text-red-600 rounded-md hover:bg-red-50 hover:border-red-300 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
//                     >
//                       {microsoftActionLoading ? (
//                         <Loader2 size={16} className="animate-spin" />
//                       ) : (
//                         <>
//                           <MicrosoftIcon size={16} />
//                           <Unlink size={14} />
//                         </>
//                       )}
//                       {microsoftActionLoading ? 'Disconnecting...' : 'Disconnect Microsoft'}
//                     </button>
//                   ) : (
//                     <button
//                       onClick={handleConnectMicrosoft}
//                       disabled={microsoftActionLoading}
//                       className="px-4 py-2 text-sm bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 hover:border-gray-400 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
//                     >
//                       {microsoftActionLoading ? (
//                         <Loader2 size={16} className="animate-spin text-gray-500" />
//                       ) : (
//                         <MicrosoftIcon size={16} />
//                       )}
//                       {microsoftActionLoading ? 'Connecting...' : 'Sync with Microsoft'}
//                     </button>
//                   )}
//                 </>
//               ) : (
//                 <>
//                   <button
//                     onClick={handleCancel}
//                     className="px-4 py-2 text-sm border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 flex items-center gap-2"
//                   >
//                     <X size={16} />
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleSave}
//                     className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-2"
//                   >
//                     <Save size={16} />
//                     Save Changes
//                   </button>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="max-w-7xl mx-auto px-6 py-8">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//           {/* Main Profile Card */}
//           <div className="lg:col-span-2 space-y-6">
//             {/* Personal Information */}
//             <div className="bg-white rounded-lg shadow-sm border">
//               <div className="px-6 py-4 border-b">
//                 <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
//                   <User size={20} />
//                   Personal Information
//                 </h2>
//               </div>
//               <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">First Name</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.firstName || ''} onChange={(e) => handleInputChange('firstName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900 font-medium">{currentData.firstName || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Last Name</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.lastName || ''} onChange={(e) => handleInputChange('lastName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900 font-medium">{currentData.lastName || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Email</label>
//                   <p className="text-sm text-gray-900 font-medium flex items-center gap-2">
//                     <Mail size={14} className="text-gray-400" />
//                     {currentData.email || '-'}
//                   </p>
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Contact Number</label>
//                   {isEditing ? (
//                     <div className="flex gap-2">
//                       <input type="text" value={currentData.countryCode || '+91'} onChange={(e) => handleInputChange('countryCode', e.target.value)} className="w-20 px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                       <input type="text" value={currentData.contactNumber || ''} onChange={(e) => handleInputChange('contactNumber', e.target.value)} className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                     </div>
//                   ) : (
//                     <p className="text-sm text-gray-900 font-medium flex items-center gap-2">
//                       <Phone size={14} className="text-gray-400" />
//                       {currentData.countryCode} {currentData.contactNumber || '-'}
//                     </p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Role</label>
//                   <p className="text-sm text-gray-900 font-medium">{currentData.role || '-'}</p>
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Created At</label>
//                   <p className="text-sm text-gray-900">{formatDate(currentData.createdAt)}</p>
//                 </div>
//               </div>
//             </div>

//             {/* Organization Information */}
//             <div className="bg-white rounded-lg shadow-sm border">
//               <div className="px-6 py-4 border-b">
//                 <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
//                   <Building size={20} />
//                   Organization Details
//                 </h2>
//               </div>
//               <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Organization Name</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.organizationName || ''} onChange={(e) => handleInputChange('organizationName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900 font-medium">{currentData.organizationName || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Organization Type</label>
//                   {isEditing ? (
//                     <select value={currentData.organizationType || 'CORPORATE'} onChange={(e) => handleInputChange('organizationType', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm">
//                       <option value="CORPORATE">Corporate</option>
//                       <option value="INDIVIDUAL">Individual</option>
//                       <option value="PARTNERSHIP">Partnership</option>
//                       <option value="LLP">LLP</option>
//                     </select>
//                   ) : (
//                     <p className="text-sm text-gray-900 font-medium">{currentData.organizationType || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">GST Number</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.gstnumber || ''} onChange={(e) => handleInputChange('gstnumber', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900 font-medium">{currentData.gstnumber || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">PAN Number</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.pannumber || ''} onChange={(e) => handleInputChange('pannumber', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900 font-medium">{currentData.pannumber || '-'}</p>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Address Information */}
//             <div className="bg-white rounded-lg shadow-sm border">
//               <div className="px-6 py-4 border-b">
//                 <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
//                   <MapPin size={20} />
//                   Address
//                 </h2>
//               </div>
//               <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div className="md:col-span-2">
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Street Line 1</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.streetLine1 || ''} onChange={(e) => handleInputChange('streetLine1', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900">{currentData.streetLine1 || '-'}</p>
//                   )}
//                 </div>
//                 <div className="md:col-span-2">
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Street Line 2</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.streetLine2 || ''} onChange={(e) => handleInputChange('streetLine2', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900">{currentData.streetLine2 || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">City</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.city || ''} onChange={(e) => handleInputChange('city', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900">{currentData.city || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">State</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.state || ''} onChange={(e) => handleInputChange('state', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900">{currentData.state || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Country</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.country || ''} onChange={(e) => handleInputChange('country', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900">{currentData.country || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Zipcode</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.zipcode || ''} onChange={(e) => handleInputChange('zipcode', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900">{currentData.zipcode || '-'}</p>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Bank Details */}
//             <div className="bg-white rounded-lg shadow-sm border">
//               <div className="px-6 py-4 border-b">
//                 <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
//                   <CreditCard size={20} />
//                   Bank Details
//                 </h2>
//               </div>
//               <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Account Number</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.accountno || ''} onChange={(e) => handleInputChange('accountno', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900 font-medium">{currentData.accountno || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">IFSC Code</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.ifsccode || ''} onChange={(e) => handleInputChange('ifsccode', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900 font-medium">{currentData.ifsccode || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Account Name</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.accountname || ''} onChange={(e) => handleInputChange('accountname', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900">{currentData.accountname || '-'}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Bank Name</label>
//                   {isEditing ? (
//                     <input type="text" value={currentData.bankname || ''} onChange={(e) => handleInputChange('bankname', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" />
//                   ) : (
//                     <p className="text-sm text-gray-900">{currentData.bankname || '-'}</p>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Sidebar */}
//           <div className="space-y-6">
//             {/* Status Card */}
//             <div className="bg-white rounded-lg shadow-sm border">
//               <div className="px-6 py-4 border-b">
//                 <h2 className="text-lg font-semibold text-gray-900">Account Status</h2>
//               </div>
//               <div className="p-6 space-y-4">
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-2">Account Status</label>
//                   {getStatusBadge(currentData.actionStatus)}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-2">Payment Status</label>
//                   {getPaymentStatusBadge(currentData.paymentStatus)}
//                 </div>
//                 <div>
//                   <label className="block text-xs font-medium text-gray-500 mb-1">Number of Users</label>
//                   <p className="text-2xl font-bold text-gray-900">{currentData.noOfUsers || 0}</p>
//                 </div>
//               </div>
//             </div>

//             {/* Connected Accounts Card */}
//             <div className="bg-white rounded-lg shadow-sm border">
//               <div className="px-6 py-4 border-b">
//                 <h2 className="text-lg font-semibold text-gray-900">Connected Accounts</h2>
//                 <p className="text-xs text-gray-500 mt-1">Sync your calendar & contacts</p>
//               </div>
//               <div className="p-6 space-y-3">

//                 {/* Google */}
//                 {googleStatusLoading ? (
//                   <div className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-gray-100 bg-gray-50">
//                     <Loader2 size={20} className="animate-spin text-gray-400 shrink-0" />
//                     <div className="flex-1">
//                       <p className="text-sm font-medium text-gray-400">Checking status...</p>
//                       <p className="text-xs text-gray-300">Gmail & Google Calendar</p>
//                     </div>
//                   </div>
//                 ) : googleConnected ? (
//                   <div className="w-full rounded-lg border border-green-200 bg-green-50 overflow-hidden">
//                     <div className="flex items-center gap-3 px-4 py-3">
//                       <GoogleIcon size={20} />
//                       <div className="flex-1 min-w-0">
//                         <div className="flex items-center gap-2">
//                           <p className="text-sm font-medium text-gray-800">Google</p>
//                           <span className="flex items-center gap-1 text-xs font-medium text-green-700 bg-green-100 px-2 py-0.5 rounded-full">
//                             <CheckCircle2 size={10} />
//                             Connected
//                           </span>
//                         </div>
//                         <p className="text-xs text-gray-400">Gmail & Google Calendar</p>
//                       </div>
//                     </div>
//                     <button
//                       onClick={handleDisconnectGoogle}
//                       disabled={googleActionLoading}
//                       className="w-full flex items-center justify-center gap-2 px-4 py-2 text-xs font-medium text-red-600 hover:bg-red-50 border-t border-green-200 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
//                     >
//                       {googleActionLoading ? <Loader2 size={12} className="animate-spin" /> : <Unlink size={12} />}
//                       {googleActionLoading ? 'Disconnecting...' : 'Disconnect'}
//                     </button>
//                   </div>
//                 ) : (
//                   <button
//                     onClick={handleConnectGoogle}
//                     disabled={googleActionLoading}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all text-left group disabled:opacity-60 disabled:cursor-not-allowed"
//                   >
//                     {googleActionLoading ? (
//                       <Loader2 size={20} className="animate-spin text-gray-400 shrink-0" />
//                     ) : (
//                       <GoogleIcon size={20} />
//                     )}
//                     <div className="flex-1 min-w-0">
//                       <p className="text-sm font-medium text-gray-800 group-hover:text-blue-700">
//                         {googleActionLoading ? 'Connecting...' : 'Connect Google'}
//                       </p>
//                       <p className="text-xs text-gray-400">Gmail & Google Calendar</p>
//                     </div>
//                     <span className="text-xs text-gray-400 group-hover:text-blue-500">→</span>
//                   </button>
//                 )}

//                 {/* Microsoft */}
//                 {microsoftStatusLoading ? (
//                   <div className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-gray-100 bg-gray-50">
//                     <Loader2 size={20} className="animate-spin text-gray-400 shrink-0" />
//                     <div className="flex-1">
//                       <p className="text-sm font-medium text-gray-400">Checking status...</p>
//                       <p className="text-xs text-gray-300">Outlook & Teams</p>
//                     </div>
//                   </div>
//                 ) : microsoftConnected ? (
//                   <div className="w-full rounded-lg border border-blue-200 bg-blue-50 overflow-hidden">
//                     <div className="flex items-center gap-3 px-4 py-3">
//                       <MicrosoftIcon size={20} />
//                       <div className="flex-1 min-w-0">
//                         <div className="flex items-center gap-2">
//                           <p className="text-sm font-medium text-gray-800">Microsoft</p>
//                           <span className="flex items-center gap-1 text-xs font-medium text-blue-700 bg-blue-100 px-2 py-0.5 rounded-full">
//                             <CheckCircle2 size={10} />
//                             Connected
//                           </span>
//                         </div>
//                         <p className="text-xs text-gray-400">Outlook & Teams</p>
//                       </div>
//                     </div>
//                     <button
//                       onClick={handleDisconnectMicrosoft}
//                       disabled={microsoftActionLoading}
//                       className="w-full flex items-center justify-center gap-2 px-4 py-2 text-xs font-medium text-red-600 hover:bg-red-50 border-t border-blue-200 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
//                     >
//                       {microsoftActionLoading ? <Loader2 size={12} className="animate-spin" /> : <Unlink size={12} />}
//                       {microsoftActionLoading ? 'Disconnecting...' : 'Disconnect'}
//                     </button>
//                   </div>
//                 ) : (
//                   <button
//                     onClick={handleConnectMicrosoft}
//                     disabled={microsoftActionLoading}
//                     className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all text-left group disabled:opacity-60 disabled:cursor-not-allowed"
//                   >
//                     {microsoftActionLoading ? (
//                       <Loader2 size={20} className="animate-spin text-gray-400 shrink-0" />
//                     ) : (
//                       <MicrosoftIcon size={20} />
//                     )}
//                     <div className="flex-1 min-w-0">
//                       <p className="text-sm font-medium text-gray-800 group-hover:text-blue-700">
//                         {microsoftActionLoading ? 'Connecting...' : 'Connect Microsoft'}
//                       </p>
//                       <p className="text-xs text-gray-400">Outlook & Teams</p>
//                     </div>
//                     <span className="text-xs text-gray-400 group-hover:text-blue-500">→</span>
//                   </button>
//                 )}

//               </div>
//             </div>

//             {/* Quick Stats */}
//             <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg shadow-sm text-white p-6">
//               <h3 className="text-lg font-semibold mb-4">Account Summary</h3>
//               <div className="space-y-3">
//                 <div className="flex items-center justify-between">
//                   <span className="text-blue-100 text-sm">Member Since</span>
//                   <span className="font-medium text-sm">{formatDate(currentData.createdAt)}</span>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <span className="text-blue-100 text-sm">Account ID</span>
//                   <span className="font-mono text-xs">{currentData.id?.slice(0, 8)}...</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Profile;

import React, { useState, useEffect, useRef } from 'react';
import { User, Mail, Phone, Building, Loader2, CheckCircle2, Unlink, Star, Upload, Lock, Eye, EyeOff } from 'lucide-react';
import { toast } from "react-toastify";
import { authAPI, employeesAPI } from "../../services/api";
import { isPasswordValid, PASSWORD_REQUIREMENT_TEXT } from "../../utils/passwordPolicy";

const GoogleIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const MicrosoftIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
    <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
    <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
  </svg>
);

const Profile = () => {
  // Single gate: page stays on spinner until ALL data is loaded
  const [ready, setReady] = useState(false);

  const [profile, setProfile] = useState(null);
  const [googleConnected, setGoogleConnected] = useState(false);
  const [microsoftConnected, setMicrosoftConnected] = useState(false);
  const [defaultProvider, setDefaultProvider] = useState(null);

  // Only used for user-triggered actions after initial load
  const [googleActionLoading, setGoogleActionLoading] = useState(false);
  const [microsoftActionLoading, setMicrosoftActionLoading] = useState(false);
  const [setDefaultLoading, setSetDefaultLoading] = useState(null);
  const [logoUploading, setLogoUploading] = useState(false);
  const logoInputRef = useRef(null);

  const isEmployee = localStorage.getItem('loginType') === 'employee';
  const [pwForm, setPwForm] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
  const [pwLoading, setPwLoading] = useState(false);
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showPwForm, setShowPwForm] = useState(false);
  const [isEditingOrg, setIsEditingOrg] = useState(false);
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [isEditingBank, setIsEditingBank] = useState(false);
  const [editData, setEditData] = useState({});

  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  // ── Single init: fetch profile then all statuses in parallel ─────────────────
  useEffect(() => {
    const init = async () => {
      try {
        if (isEmployee) {
          let empProfile = null;
          const userId = localStorage.getItem('userId');
          // Try API first — gets full profile including status and createdAt
          if (userId) {
            try {
              const res = await employeesAPI.getEmployeeById(userId);
              const d = res.data;
              const nameParts = (d.name || '').trim().split(' ');
              empProfile = {
                firstName: nameParts[0] || '',
                lastName: nameParts.slice(1).join(' ') || '',
                email: d.email || '',
                phoneNumber: d.phoneNumber || '',
                roles: d.roles || [],
                status: d.status || '',
                createdAt: d.createdAt || null,
                createdBy: d.createdBy || '',
              };
            } catch { /* fall through to localStorage */ }
          }
          // Fallback: read from localStorage
          if (!empProfile) {
            try {
              const raw = localStorage.getItem('userProfile');
              const parsed = raw ? JSON.parse(raw) : {};
              const nameParts = (parsed.name || '').trim().split(' ');
              empProfile = {
                firstName: parsed.firstName || nameParts[0] || '',
                lastName: parsed.lastName || nameParts.slice(1).join(' ') || '',
                email: parsed.email || localStorage.getItem('email') || '',
                phoneNumber: parsed.phoneNumber || '',
                roles: parsed.roles || [],
                status: parsed.status || '',
                createdAt: parsed.createdAt || null,
                createdBy: parsed.createdBy || '',
              };
            } catch {
              empProfile = {
                firstName: '', lastName: '', email: localStorage.getItem('email') || '',
                phoneNumber: '', roles: [], status: '', createdAt: null, createdBy: '',
              };
            }
          }
          setProfile(empProfile);
          setReady(true);
          return;
        }

        const email = localStorage.getItem('userEmail') || localStorage.getItem('email');
        if (!email) {
          toast.error('User email not found. Please login again.');
          return;
        }

        // 1. Get profile first (need userId)
        const profileRes = await authAPI.getProfile(email);
        if (!mountedRef.current) return;

        const profileData = profileRes.data;
        const userId = profileData?.id;

        if (!userId) {
          setProfile(profileData);
          return;
        }

        // 2. Fetch all three statuses in parallel — no sequential renders
        const [googleRes, microsoftRes, defaultRes] = await Promise.allSettled([
          authAPI.googleStatus(userId),
          authAPI.microsoftStatus(userId),
          authAPI.getDefaultProvider(userId),
        ]);

        if (!mountedRef.current) return;

        if (googleRes.status === 'fulfilled') {
          const d = googleRes.value.data;
          setGoogleConnected(d?.connected ?? d?.status === 'connected' ?? false);
        }

        if (microsoftRes.status === 'fulfilled') {
          const d = microsoftRes.value.data;
          setMicrosoftConnected(d?.connected ?? d?.status === 'connected' ?? false);
        }

        if (defaultRes.status === 'fulfilled') {
          const d = defaultRes.value.data;
          const p = d?.provider || d?.defaultProvider || null;
          setDefaultProvider(p ? p.toUpperCase() : null);
        }

        // Set profile last so the entire page renders once with all data
        setProfile(profileData);
      } catch (err) {
        console.error('Profile init error:', err);
        if (mountedRef.current) toast.error('Failed to load profile');
      } finally {
        if (mountedRef.current) setReady(true);
      }
    };

    init();
  }, []); // runs exactly once

  // ── Google handlers ──────────────────────────────────────────────────────────
  const handleConnectGoogle = async () => {
    setGoogleActionLoading(true);
    try {
      const userId = profile?.id || localStorage.getItem('userId');
      if (!userId) { toast.error('User ID not found.'); return; }
      const { data } = await authAPI.connectGoogle(userId);
      if (data?.url) window.location.href = data.url;
      else toast.error('Failed to get Google authorization URL');
    } catch (err) {
      console.error(err);
      toast.error('Failed to initiate Google connection');
    } finally {
      if (mountedRef.current) setGoogleActionLoading(false);
    }
  };

  const handleDisconnectGoogle = async () => {
    setGoogleActionLoading(true);
    try {
      const userId = profile?.id || localStorage.getItem('userId');
      if (!userId) { toast.error('User ID not found.'); return; }
      await authAPI.disconnectGoogle(userId);
      if (!mountedRef.current) return;
      setGoogleConnected(false);
      if (defaultProvider === 'GOOGLE') setDefaultProvider(null);
      toast.success('Google account disconnected successfully');
    } catch (err) {
      console.error(err);
      if (mountedRef.current) toast.error('Failed to disconnect Google account');
    } finally {
      if (mountedRef.current) setGoogleActionLoading(false);
    }
  };

  // ── Microsoft handlers ───────────────────────────────────────────────────────
  const handleConnectMicrosoft = async () => {
    setMicrosoftActionLoading(true);
    try {
      const userId = profile?.id || localStorage.getItem('userId');
      if (!userId) { toast.error('User ID not found.'); return; }
      const { data } = await authAPI.connectMicrosoft(userId);
      if (data?.url) window.location.href = data.url;
      else toast.error('Failed to get Microsoft authorization URL');
    } catch (err) {
      console.error(err);
      toast.error('Failed to initiate Microsoft connection');
    } finally {
      if (mountedRef.current) setMicrosoftActionLoading(false);
    }
  };

  const handleDisconnectMicrosoft = async () => {
    setMicrosoftActionLoading(true);
    try {
      const userId = profile?.id || localStorage.getItem('userId');
      if (!userId) { toast.error('User ID not found.'); return; }
      await authAPI.disconnectMicrosoft(userId);
      if (!mountedRef.current) return;
      setMicrosoftConnected(false);
      if (defaultProvider === 'MICROSOFT') setDefaultProvider(null);
      toast.success('Microsoft account disconnected successfully');
    } catch (err) {
      console.error(err);
      if (mountedRef.current) toast.error('Failed to disconnect Microsoft account');
    } finally {
      if (mountedRef.current) setMicrosoftActionLoading(false);
    }
  };

  // ── Default provider ─────────────────────────────────────────────────────────
  const handleSetDefaultProvider = async (provider) => {
    if (defaultProvider === provider) return;
    const userId = profile?.id || localStorage.getItem('userId');
    if (!userId) { toast.error('User ID not found.'); return; }
    setSetDefaultLoading(provider);
    try {
      await authAPI.setDefaultProvider(userId, provider);
      if (!mountedRef.current) return;
      setDefaultProvider(provider);
      toast.success(`${provider.charAt(0) + provider.slice(1).toLowerCase()} set as default provider`);
    } catch (err) {
      console.error(err);
      if (mountedRef.current) toast.error('Failed to set default provider');
    } finally {
      if (mountedRef.current) setSetDefaultLoading(null);
    }
  };

  // ── Logo upload ──────────────────────────────────────────────────────────────
  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 500 * 1024) {
      toast.error('Logo must be under 500KB');
      return;
    }
    if (!['image/png', 'image/jpeg', 'image/svg+xml'].includes(file.type)) {
      toast.error('Please upload PNG, JPG or SVG');
      return;
    }
    setLogoUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await authAPI.uploadLogo(formData);
      setProfile(prev => ({ ...prev, logoUrl: response.data.logoUrl }));
      toast.success('Logo uploaded successfully');
    } catch (err) {
      toast.error('Failed to upload logo. Please try again.');
    } finally {
      setLogoUploading(false);
    }
  };

  // ── Change password (employees only) ────────────────────────────────────────
  const handleChangePassword = async () => {
    if (!pwForm.oldPassword || !pwForm.newPassword || !pwForm.confirmPassword) {
      toast.warning('Please fill in all password fields');
      return;
    }
    if (pwForm.newPassword !== pwForm.confirmPassword) {
      toast.warning('New passwords do not match');
      return;
    }
    if (!isPasswordValid(pwForm.newPassword)) {
      toast.warning(PASSWORD_REQUIREMENT_TEXT);
      return;
    }
    const userId = localStorage.getItem('userId');
    if (!userId) { toast.error('User ID not found. Please login again.'); return; }
    setPwLoading(true);
    try {
      await employeesAPI.updatePassword(userId, pwForm.oldPassword, pwForm.newPassword);
      toast.success('Password changed successfully');
      setPwForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
      setShowPwForm(false);
    } catch (err) {
      const msg = err.response?.data?.message || err.response?.data;
      toast.error(typeof msg === 'string' ? msg : 'Failed to change password');
    } finally {
      setPwLoading(false);
    }
  };

  // ── Helpers ──────────────────────────────────────────────────────────────────
  const formatDate = (ds) => {
    if (!ds) return 'N/A';
    return new Date(ds).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const StatusBadge = ({ status }) => {
    const cfg = {
      ACTIVATED: { bg: 'bg-green-100', text: 'text-green-800', label: 'Active' },
      DEACTIVATED: { bg: 'bg-red-100', text: 'text-red-800', label: 'Inactive' },
      PENDING: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Pending' },
    }[status] || { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Pending' };
    return <span className={`px-3 py-1 text-xs font-medium rounded-full ${cfg.bg} ${cfg.text}`}>{cfg.label}</span>;
  };

  const PaymentBadge = ({ status }) => {
    const cfg = {
      PAID: { bg: 'bg-green-100', text: 'text-green-800' },
      UNPAID: { bg: 'bg-red-100', text: 'text-red-800' },
      PENDING: { bg: 'bg-yellow-100', text: 'text-yellow-800' },
    }[status] || { bg: 'bg-red-100', text: 'text-red-800' };
    return <span className={`px-3 py-1 text-xs font-medium rounded-full ${cfg.bg} ${cfg.text}`}>{status}</span>;
  };

  // ── Provider card ─────────────────────────────────────────────────────────────
  const ProviderCard = ({ providerKey, label, subLabel, Icon, connected, actionLoading, onConnect, onDisconnect, borderColor, bgColor, badgeColor, badgeText, dividerColor }) => {
    const isDefault = defaultProvider === providerKey;
    const isSettingDefault = setDefaultLoading === providerKey;

    if (connected) {
      return (
        <div className={`w-full rounded-lg border ${borderColor} ${bgColor} overflow-hidden`}>
          <div className="flex items-center gap-3 px-4 py-3">
            <Icon size={20} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <p className="text-sm font-medium text-gray-800">{label}</p>
                <span className={`flex items-center gap-1 text-xs font-medium ${badgeText} ${badgeColor} px-2 py-0.5 rounded-full`}>
                  <CheckCircle2 size={10} /> Connected
                </span>
                {isDefault && (
                  <span className="flex items-center gap-1 text-xs font-medium text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full">
                    <Star size={9} fill="currentColor" /> Default
                  </span>
                )}
              </div>
              <p className="text-xs text-gray-400">{subLabel}</p>
            </div>
          </div>
          <div className={`flex border-t ${dividerColor}`}>
            <button
              onClick={() => handleSetDefaultProvider(providerKey)}
              disabled={isDefault || isSettingDefault}
              className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-medium transition-colors
                ${isDefault ? 'text-amber-600 bg-amber-50 cursor-default' : 'text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'}`}
            >
              {isSettingDefault ? <Loader2 size={11} className="animate-spin" /> : <Star size={11} fill={isDefault ? 'currentColor' : 'none'} />}
              {isDefault ? 'Default' : isSettingDefault ? 'Setting...' : 'Set as Default'}
            </button>
            <div className={`w-px ${dividerColor}`} />
            <button
              onClick={onDisconnect}
              disabled={actionLoading}
              className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-medium text-red-600 hover:bg-red-50 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {actionLoading ? <Loader2 size={11} className="animate-spin" /> : <Unlink size={11} />}
              {actionLoading ? 'Disconnecting...' : 'Disconnect'}
            </button>
          </div>
        </div>
      );
    }

    return (
      <button
        onClick={onConnect}
        disabled={actionLoading}
        className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all text-left group disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {actionLoading ? <Loader2 size={20} className="animate-spin text-gray-400 shrink-0" /> : <Icon size={20} />}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-800 group-hover:text-blue-700">
            {actionLoading ? 'Connecting...' : `Connect ${label}`}
          </p>
          <p className="text-xs text-gray-400">{subLabel}</p>
        </div>
        {!actionLoading && <span className="text-xs text-gray-400 group-hover:text-blue-500">→</span>}
      </button>
    );
  };

  // ── Guards ────────────────────────────────────────────────────────────────────
  if (!ready) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
        <User size={64} className="text-gray-300 mb-4" />
        <p className="text-lg font-medium text-gray-600">No profile data available</p>
      </div>
    );
  }

  // ── Employee profile page ─────────────────────────────────────────────────────
  if (isEmployee) {
    const ROLE_LABELS = { ATS: 'ATS', CRM: 'CRM', INVOICE: 'Invoice', USER_MANAGEMENT: 'User Management' };
    const rolesArray = Array.isArray(profile.roles) ? profile.roles : profile.roles ? [profile.roles] : [];
    const memberSince = profile.createdAt
      ? new Date(profile.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
      : '';
    const statusUpper = (profile.status || '').toUpperCase();
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="bg-white border-b">
          <div className="max-w-3xl mx-auto px-6 py-6">
            <h1 className="text-2xl font-bold text-gray-900">My Profile</h1>
            <p className="text-sm text-gray-500 mt-1">Manage your account information</p>
          </div>
        </div>
        <div className="max-w-3xl mx-auto px-6 py-8 space-y-6">

          {/* Section 1 — Personal Information */}
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="px-6 py-4 border-b">
              <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><User size={20} /> Personal Information</h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">First Name</label>
                <p className="text-sm text-gray-900 font-medium">{profile.firstName}</p>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">Last Name</label>
                <p className="text-sm text-gray-900 font-medium">{profile.lastName}</p>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">Email</label>
                <p className="text-sm text-gray-900 font-medium flex items-center gap-2"><Mail size={14} className="text-gray-400" />{profile.email}</p>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">Phone Number</label>
                <p className="text-sm text-gray-900 font-medium flex items-center gap-2"><Phone size={14} className="text-gray-400" />{profile.phoneNumber}</p>
              </div>
            </div>
          </div>

          {/* Section 2 — My Roles */}
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="px-6 py-4 border-b">
              <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><CheckCircle2 size={20} /> My Roles</h2>
            </div>
            <div className="p-6 flex flex-wrap gap-2">
              {rolesArray.length > 0 ? rolesArray.map((r, i) => {
                const key = String(r).toUpperCase().trim().replace(/^ROLE_/, '');
                return (
                  <span key={i} className="px-3 py-1 text-xs font-medium text-white rounded-full" style={{ backgroundColor: '#3B5A67' }}>
                    {ROLE_LABELS[key] || key}
                  </span>
                );
              }) : <p className="text-sm text-gray-400">No roles assigned</p>}
            </div>
          </div>

          {/* Section 3 — Employment Details */}
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="px-6 py-4 border-b">
              <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><Building size={20} /> Employment Details</h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">Member Since</label>
                <p className="text-sm text-gray-900 font-medium">{memberSince}</p>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">Status</label>
                {statusUpper === 'ACTIVE' && <span className="px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">Active</span>}
                {statusUpper === 'INACTIVE' && <span className="px-3 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800">Inactive</span>}
                {statusUpper !== 'ACTIVE' && statusUpper !== 'INACTIVE' && <p className="text-sm text-gray-900 font-medium">{profile.status}</p>}
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">Added By</label>
                <p className="text-sm text-gray-900 font-medium">
                  {localStorage.getItem('organizationName') || 'Admin'}
                </p>
              </div>
            </div>
          </div>

          {/* Section 4 — Change Password */}
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="px-6 py-4 border-b flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><Lock size={20} /> Change Password</h2>
              {!showPwForm && (
                <button
                  onClick={() => setShowPwForm(true)}
                  className="px-4 py-1.5 text-sm font-medium text-white rounded-md"
                  style={{ backgroundColor: '#1C4E6D' }}
                >
                  Change Password
                </button>
              )}
            </div>
            {showPwForm && (
              <div className="p-6 space-y-4">
                {[
                  { label: 'Current Password', key: 'oldPassword', show: showOld, toggle: () => setShowOld(p => !p) },
                  { label: 'New Password', key: 'newPassword', show: showNew, toggle: () => setShowNew(p => !p) },
                  { label: 'Confirm New Password', key: 'confirmPassword', show: showConfirm, toggle: () => setShowConfirm(p => !p) },
                ].map(({ label, key, show, toggle }) => (
                  <div key={key}>
                    <label className="block text-xs font-medium text-gray-700 mb-1">{label}</label>
                    <div className="relative">
                      <input
                        type={show ? 'text' : 'password'}
                        value={pwForm[key]}
                        onChange={e => setPwForm(p => ({ ...p, [key]: e.target.value }))}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1C4E6D] pr-10"
                        placeholder={`Enter ${label.toLowerCase()}`}
                      />
                      <button type="button" onClick={toggle} className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600">
                        {show ? <EyeOff size={16} /> : <Eye size={16} />}
                      </button>
                    </div>
                  </div>
                ))}
                <div className="pt-2 flex items-center gap-3">
                  <button
                    onClick={handleChangePassword}
                    disabled={pwLoading}
                    className="px-6 py-2 text-sm font-medium text-white rounded-md disabled:opacity-60 disabled:cursor-not-allowed flex items-center gap-2"
                    style={{ backgroundColor: '#1C4E6D' }}
                  >
                    {pwLoading && <Loader2 size={16} className="animate-spin" />}
                    {pwLoading ? 'Updating...' : 'Update Password'}
                  </button>
                  <button
                    onClick={() => { setShowPwForm(false); setPwForm({ oldPassword: '', newPassword: '', confirmPassword: '' }); }}
                    className="px-4 py-2 text-sm font-medium text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  const handleProfileSave = async (section) => {
    try {
      await authAPI.updateProfile(editData);
      setProfile(prev => ({ ...prev, ...editData }));
      const stored = localStorage.getItem('userProfile');
      if (stored) {
        const parsed = JSON.parse(stored);
        localStorage.setItem('userProfile', JSON.stringify({ ...parsed, ...editData }));
      }
      try {
        const freshProfile = await authAPI.getProfile(profile.email);
        if (freshProfile.data) {
          localStorage.setItem('userProfile', JSON.stringify(freshProfile.data));
          setProfile(freshProfile.data);
        }
      } catch (e) {
        console.error('Could not refresh profile from backend', e);
      }
      if (section === 'org') setIsEditingOrg(false);
      if (section === 'address') setIsEditingAddress(false);
      if (section === 'bank') setIsEditingBank(false);
      setEditData({});
      toast.success('Profile updated successfully');
    } catch (e) {
      toast.error('Failed to update profile');
    }
  };

  // ── Page — rendered exactly once, after all data is ready ────────────────────
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">My Profile</h1>
              <p className="text-sm text-gray-500 mt-1">View your account information</p>
            </div>
            <div className="flex items-center gap-3">
              {/* Google */}
              {googleConnected ? (
                <button onClick={handleDisconnectGoogle} disabled={googleActionLoading}
                  className="px-4 py-2 text-sm bg-white border border-red-200 text-red-600 rounded-md hover:bg-red-50 hover:border-red-300 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed">
                  {googleActionLoading ? <Loader2 size={16} className="animate-spin" /> : <><GoogleIcon size={16} /><Unlink size={14} /></>}
                  {googleActionLoading ? 'Disconnecting...' : 'Disconnect Google'}
                </button>
              ) : (
                <button onClick={handleConnectGoogle} disabled={googleActionLoading}
                  className="px-4 py-2 text-sm bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 hover:border-gray-400 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed">
                  {googleActionLoading ? <Loader2 size={16} className="animate-spin text-gray-500" /> : <GoogleIcon size={16} />}
                  {googleActionLoading ? 'Connecting...' : 'Sync with Google'}
                </button>
              )}

              {/* Microsoft */}
              {microsoftConnected ? (
                <button onClick={handleDisconnectMicrosoft} disabled={microsoftActionLoading}
                  className="px-4 py-2 text-sm bg-white border border-red-200 text-red-600 rounded-md hover:bg-red-50 hover:border-red-300 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed">
                  {microsoftActionLoading ? <Loader2 size={16} className="animate-spin" /> : <><MicrosoftIcon size={16} /><Unlink size={14} /></>}
                  {microsoftActionLoading ? 'Disconnecting...' : 'Disconnect Microsoft'}
                </button>
              ) : (
                <button onClick={handleConnectMicrosoft} disabled={microsoftActionLoading}
                  className="px-4 py-2 text-sm bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 hover:border-gray-400 flex items-center gap-2 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed">
                  {microsoftActionLoading ? <Loader2 size={16} className="animate-spin text-gray-500" /> : <MicrosoftIcon size={16} />}
                  {microsoftActionLoading ? 'Connecting...' : 'Sync with Microsoft'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

          {/* Left */}
          <div className="lg:col-span-2 space-y-6">

            <div className="bg-white rounded-lg shadow-sm border">
              <div className="px-6 py-4 border-b">
                <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><User size={20} /> Personal Information</h2>
              </div>
              <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div><label className="block text-xs font-medium text-gray-500 mb-1">First Name</label><p className="text-sm text-gray-900 font-medium">{profile.firstName || '-'}</p></div>
                <div><label className="block text-xs font-medium text-gray-500 mb-1">Last Name</label><p className="text-sm text-gray-900 font-medium">{profile.lastName || '-'}</p></div>
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">Email</label>
                  <p className="text-sm text-gray-900 font-medium flex items-center gap-2"><Mail size={14} className="text-gray-400" />{profile.email || '-'}</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">Contact Number</label>
                  <p className="text-sm text-gray-900 font-medium flex items-center gap-2"><Phone size={14} className="text-gray-400" />{profile.countryCode} {profile.contactNumber || '-'}</p>
                </div>
                <div><label className="block text-xs font-medium text-gray-500 mb-1">Role</label><p className="text-sm text-gray-900 font-medium">{profile.role || '-'}</p></div>
                <div><label className="block text-xs font-medium text-gray-500 mb-1">Created At</label><p className="text-sm text-gray-900">{formatDate(profile.createdAt)}</p></div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm border">
              <div className="px-6 py-4 border-b">
                <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2"><Building size={20} /> Company Logo</h2>
              </div>
              <div className="p-6">
                <div className="relative">
                  {profile.logoUrl ? (
                    <div className="flex flex-col items-start gap-2">
                      <img src={profile.logoUrl} alt="Company Logo" style={{ maxHeight: '64px', maxWidth: '200px', objectFit: 'contain' }} />
                      <button
                        onClick={() => logoInputRef.current?.click()}
                        disabled={logoUploading}
                        className="text-xs text-blue-600 cursor-pointer hover:underline disabled:opacity-50"
                      >
                        Change Logo
                      </button>
                    </div>
                  ) : (
                    <div
                      className="border-2 border-dashed border-gray-300 rounded-lg p-8 flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-colors"
                      onClick={() => !logoUploading && logoInputRef.current?.click()}
                    >
                      <Upload size={24} className="text-gray-400 mb-2" />
                      <p className="text-sm text-gray-500">Click to upload logo</p>
                      <p className="text-xs text-gray-400 mt-1">PNG, JPG or SVG • Max 500KB</p>
                    </div>
                  )}
                  {logoUploading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 rounded-lg">
                      <Loader2 size={24} className="animate-spin text-blue-500" />
                    </div>
                  )}
                </div>
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/svg+xml"
                  className="hidden"
                  ref={logoInputRef}
                  onChange={handleLogoUpload}
                />
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm border">
              <div className="px-6 py-4 border-b flex items-center justify-between">
                <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">Organization Details</h2>
                {!isEditingOrg && (
                  <button onClick={() => { setEditData({}); setIsEditingOrg(true); }}
                    className="text-sm px-3 py-1 rounded border"
                    style={{ borderColor: '#3B5A67', color: '#3B5A67' }}>Edit</button>
                )}
              </div>
              {isEditingOrg ? (
                <div className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">Organization Name</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.organizationName}
                        onChange={e => setEditData(p => ({ ...p, organizationName: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">GST Number</label>
                      <input className="w-full border rounded px-3 py-2 text-sm"
                        value={editData.GSTnumber !== undefined ? editData.GSTnumber : (profile.GSTnumber || profile.gstnumber || '')}
                        onChange={e => setEditData(p => ({ ...p, GSTnumber: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">PAN Number</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.pannumber}
                        onChange={e => setEditData(p => ({ ...p, pannumber: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">Contact Number</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.contactNumber}
                        onChange={e => setEditData(p => ({ ...p, contactNumber: e.target.value }))} /></div>
                  </div>
                  <div className="flex gap-2 justify-end mt-4">
                    <button className="text-sm px-4 py-2 rounded border border-gray-300 text-gray-600"
                      onClick={() => setIsEditingOrg(false)}>Cancel</button>
                    <button className="text-sm px-4 py-2 rounded text-white"
                      style={{ backgroundColor: '#3B5A67' }}
                      onClick={() => handleProfileSave('org')}>Save</button>
                  </div>
                </div>
              ) : (
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">Organization Name</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.organizationName}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">Organization Type</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.organizationType}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">GST Number</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.GSTnumber || profile.gstnumber}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">PAN Number</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.pannumber}</p></div>
                </div>
              )}
            </div>

            <div className="bg-white rounded-lg shadow-sm border">
              <div className="px-6 py-4 border-b flex items-center justify-between">
                <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">Address</h2>
                {!isEditingAddress && (
                  <button onClick={() => { setEditData({}); setIsEditingAddress(true); }}
                    className="text-sm px-3 py-1 rounded border"
                    style={{ borderColor: '#3B5A67', color: '#3B5A67' }}>Edit</button>
                )}
              </div>
              {isEditingAddress ? (
                <div className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">Street Line 1</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.streetLine1}
                        onChange={e => setEditData(p => ({ ...p, streetLine1: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">Street Line 2</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.streetLine2}
                        onChange={e => setEditData(p => ({ ...p, streetLine2: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">City</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.city}
                        onChange={e => setEditData(p => ({ ...p, city: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">State</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.state}
                        onChange={e => setEditData(p => ({ ...p, state: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">Country</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.country}
                        onChange={e => setEditData(p => ({ ...p, country: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">Zipcode</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.zipcode}
                        onChange={e => setEditData(p => ({ ...p, zipcode: e.target.value }))} /></div>
                  </div>
                  <div className="flex gap-2 justify-end mt-4">
                    <button className="text-sm px-4 py-2 rounded border border-gray-300 text-gray-600"
                      onClick={() => setIsEditingAddress(false)}>Cancel</button>
                    <button className="text-sm px-4 py-2 rounded text-white"
                      style={{ backgroundColor: '#3B5A67' }}
                      onClick={() => handleProfileSave('address')}>Save</button>
                  </div>
                </div>
              ) : (
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">Street Line 1</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.streetLine1}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">Street Line 2</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.streetLine2}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">City</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.city}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">State</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.state}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">Country</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.country}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">Zipcode</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.zipcode}</p></div>
                </div>
              )}
            </div>

            <div className="bg-white rounded-lg shadow-sm border">
              <div className="px-6 py-4 border-b flex items-center justify-between">
                <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">Bank Details</h2>
                {!isEditingBank && (
                  <button onClick={() => { setEditData({}); setIsEditingBank(true); }}
                    className="text-sm px-3 py-1 rounded border"
                    style={{ borderColor: '#3B5A67', color: '#3B5A67' }}>Edit</button>
                )}
              </div>
              {isEditingBank ? (
                <div className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">Account Number</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.accountno}
                        onChange={e => setEditData(p => ({ ...p, accountno: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">IFSC Code</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.ifsccode}
                        onChange={e => setEditData(p => ({ ...p, ifsccode: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">Account Name</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.accountname}
                        onChange={e => setEditData(p => ({ ...p, accountname: e.target.value }))} /></div>
                    <div><label className="block text-xs font-medium text-gray-500 mb-1">Bank Name</label>
                      <input className="w-full border rounded px-3 py-2 text-sm" defaultValue={profile.bankname}
                        onChange={e => setEditData(p => ({ ...p, bankname: e.target.value }))} /></div>
                  </div>
                  <div className="flex gap-2 justify-end mt-4">
                    <button className="text-sm px-4 py-2 rounded border border-gray-300 text-gray-600"
                      onClick={() => setIsEditingBank(false)}>Cancel</button>
                    <button className="text-sm px-4 py-2 rounded text-white"
                      style={{ backgroundColor: '#3B5A67' }}
                      onClick={() => handleProfileSave('bank')}>Save</button>
                  </div>
                </div>
              ) : (
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">Account Number</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.accountno}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">IFSC Code</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.ifsccode}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">Account Name</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.accountname}</p></div>
                  <div><label className="block text-xs font-medium text-gray-500 mb-1">Bank Name</label>
                    <p className="text-sm text-gray-900 font-medium">{profile.bankname}</p></div>
                </div>
              )}
            </div>

          </div>

          {/* Sidebar */}
          <div className="space-y-6">

            <div className="bg-white rounded-lg shadow-sm border">
              <div className="px-6 py-4 border-b"><h2 className="text-lg font-semibold text-gray-900">Account Status</h2></div>
              <div className="p-6 space-y-4">
                <div><label className="block text-xs font-medium text-gray-500 mb-2">Account Status</label><StatusBadge status={profile.actionStatus} /></div>
                <div><label className="block text-xs font-medium text-gray-500 mb-2">Payment Status</label><PaymentBadge status={profile.paymentStatus} /></div>
                <div><label className="block text-xs font-medium text-gray-500 mb-1">Number of Users</label><p className="text-2xl font-bold text-gray-900">{profile.noOfUsers || 0}</p></div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm border">
              <div className="px-6 py-4 border-b">
                <h2 className="text-lg font-semibold text-gray-900">Connected Accounts</h2>
                <p className="text-xs text-gray-500 mt-1">Sync your calendar & contacts</p>
              </div>
              <div className="p-6 space-y-3">
                <ProviderCard
                  providerKey="GOOGLE" label="Google" subLabel="Gmail & Google Calendar" Icon={GoogleIcon}
                  connected={googleConnected} actionLoading={googleActionLoading}
                  onConnect={handleConnectGoogle} onDisconnect={handleDisconnectGoogle}
                  borderColor="border-green-200" bgColor="bg-green-50" badgeColor="bg-green-100" badgeText="text-green-700" dividerColor="border-green-200"
                />
                <ProviderCard
                  providerKey="MICROSOFT" label="Microsoft" subLabel="Outlook & Teams" Icon={MicrosoftIcon}
                  connected={microsoftConnected} actionLoading={microsoftActionLoading}
                  onConnect={handleConnectMicrosoft} onDisconnect={handleDisconnectMicrosoft}
                  borderColor="border-blue-200" bgColor="bg-blue-50" badgeColor="bg-blue-100" badgeText="text-blue-700" dividerColor="border-blue-200"
                />
                {(googleConnected || microsoftConnected) && (
                  <p className="text-xs text-gray-400 pt-1 flex items-center gap-1">
                    <Star size={10} fill="currentColor" className="text-amber-400" />
                    Tap "Set as Default" to choose your primary provider.
                  </p>
                )}
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg shadow-sm text-white p-6">
              <h3 className="text-lg font-semibold mb-4">Account Summary</h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-blue-100 text-sm">Member Since</span>
                  <span className="font-medium text-sm">{formatDate(profile.createdAt)}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-blue-100 text-sm">Account ID</span>
                  <span className="font-mono text-xs">{profile.id?.slice(0, 8)}...</span>
                </div>
                {defaultProvider && (
                  <div className="flex items-center justify-between">
                    <span className="text-blue-100 text-sm">Default Provider</span>
                    <span className="font-medium text-sm flex items-center gap-1">
                      <Star size={11} fill="currentColor" className="text-amber-300" />
                      {defaultProvider.charAt(0) + defaultProvider.slice(1).toLowerCase()}
                    </span>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;

